import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactFormService {
  private readonly endpoint = `${environment.baseUrl}public/business-contacts`;

  constructor(private http: HttpClient) {}

  submitBusinessContact(payload: unknown): Observable<unknown> {
    return this.http.post(this.endpoint, payload);
  }
}
